import React from "react";

export default function Test() {
  return (
    <button>
      {" "}
      <div className="App">
        <header className="App-header">
          <img src={require("../assets/logo.jpg")} alt="Logo" />

          <div></div>
        </header>
      </div>
      <div className="App2">hello</div>
    </button>
  );
}
// <button onClick={onSubmit2}>test </button>
